import { defineStore } from 'pinia';
import type { IApplyErrorState } from '~/types/apply';

export const useApplyError = defineStore('applyError', {
  state: (): IApplyErrorState => {
    return {
      firstName: false,
      lastName: false,
      mail: false,
      areaCode: false,
      areaCode2: false,
      mobile: false,
      confirm: false,
      notes: false,
      linkedIn: false,
      cv: false,
      additionalFiles: false,
      questions: [],
      gdpr: [],
      recaptcha: false,
      isUserAgreedToPrivacyPolicy: false,
    };
  },
});
